import { useQuery } from "@tanstack/react-query";
import type { AdminDashboardFilters } from "@cdt/shared";
import {
  fetchAdminErrors,
  fetchAdminLimits,
  fetchAdminSummary,
  fetchAdminTimeseries,
  fetchAdminTopConsumers,
} from "@/lib/adminDashboardApi";

type Filters = AdminDashboardFilters & { days?: number };

export function useAdminSummary(filters: Filters) {
  return useQuery({
    queryKey: ["admin-summary", filters],
    queryFn: () => fetchAdminSummary(filters),
  });
}

export function useAdminTimeseries(filters: Filters) {
  return useQuery({
    queryKey: ["admin-timeseries", filters],
    queryFn: () => fetchAdminTimeseries(filters),
  });
}

export function useAdminTopConsumers(filters: Filters & { limit?: number }) {
  return useQuery({
    queryKey: ["admin-top", filters],
    queryFn: () => fetchAdminTopConsumers(filters),
  });
}

export function useAdminErrors(
  filters: Filters & { page?: number; pageSize?: number },
) {
  return useQuery({
    queryKey: ["admin-errors", filters],
    queryFn: () => fetchAdminErrors(filters),
  });
}

export function useAdminLimits() {
  return useQuery({
    queryKey: ["admin-limits"],
    queryFn: fetchAdminLimits,
    refetchInterval: 60_000,
  });
}
